module.exports = __webpack_public_path__ + "img/3@2x.eae15d97.png";